module.exports = __webpack_public_path__ + "img/PS-Microalambre.2f2b1a5a.png";